import { FC } from "react";
import classNames from "classnames";

interface ChartLabelProps {
	/**
	 * The eyebrow above a figure, e.g. "Chart 1.1". Defaults to "Chart";
	 * pass null (or an empty string) to leave the figure without an eyebrow.
	 * Rendered uppercase, so the casing written here does not matter.
	 */
	label?: string | null;
	className?: string;
}

const ChartLabel: FC<ChartLabelProps> = ({ label = "Chart", className }) => {
	if (!label) return null;

	return (
		<div className={classNames("flex items-center gap-3", className)}>
			<span className="shrink-0 h-px w-10 bg-black/30" />
			<span className="text-sm uppercase font-semibold tracking-widest text-black/50">{label}</span>
		</div>
	);
};

export { ChartLabel };
